/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable sonarjs/no-identical-functions */
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";

import uuid from "react-uuid";
import { ReactComponent as LeftArrow } from "../../../assets/icons/LeftArrow.svg";
import { ReactComponent as RightArrow } from "../../../assets/icons/RightArrow.svg";
import AutocompleteFloatLabel from "../../../components/AutocompleteFloatLabel";
import Dialog from "../../../components/Dialog";
import IModalProps from "../../../model/ModalProps";
import DialogStyles from "../../../styles/components/DialogStyles";
import GenericUtils from "../../../utils/GenericUtils";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import { axiosGetRequest } from "../../../api/ApiClient";
import TableStyles from "../../../styles/components/TableStyles";
import { StyledFormCheck, StyledLabel } from "../../../styles/MainStyles";
import { AutocompleteCombo } from "../../../components/Autocomplete";

interface IProfessores {
    docenteId: string;
    matriculaAdp: string;
    nome: string;
    email: string;
    isSelecionado: boolean;
}

const { StyledModalTitle, StyledContainerButton } = DialogStyles;

interface IModalSaveHolidayProps extends IModalProps {
    campus: string;
    open: boolean;
    crSelect: ICrs[];
    setCrSelect: (select: ICrs[]) => void;
    onClose(): void;
    crEdit: ICrs | undefined;
    indexCrEdit: number;
}

interface ICrs {
    cr: any[];
    professores: IProfessores[];
    isAll: boolean;
}

function ModalProfessores(props: IModalSaveHolidayProps) {
    const { BtnPrimary, BtnOutlinePrimary, DefaultButtonLink } = ButtonStyles;
    const [step, setStep] = useState(0);
    const [crs, setCrs] = useState<any[]>([]);
    const [crSelect, setCrSelect] = useState<any[]>([]);
    const [professores, setProfessores] = useState<IProfessores[]>([]);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [itensPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);

    const { instance } = useMsal();
    const acessTokenDocente = GenericUtils.getAccessTokenDocente();

    const getCR = async () => {
        setStep(0);
        setCrSelect([]);
        setProfessores([]);
        const newCRs: any = [];
        const response = await axiosGetRequest(
            `/docente/v1/centroresultados?campusId=${props.campus}&abrangenciaId=not:4&_limit=999999`,
            acessTokenDocente,
            instance
        );

        if (response.data.centroResultados) {
            response.data.centroResultados.forEach((data: any) =>
                newCRs.push({
                    value: data.id,
                    label: data.nome,
                })
            );

            setCrs(newCRs);
        }
    };

    const getProfessores = async (crId: number) => {
        const newProfs: IProfessores[] = [];
        const response = await axiosGetRequest(
            `/docente/v1/docentes?centroResultadoId=${crId}&_limit=999999999&_offset=0`,
            acessTokenDocente,
            instance
        );

        if (response.data.docentes) {
            response.data.docentes.forEach((data: any) =>
                newProfs.push({
                    docenteId: data.docenteId,
                    matriculaAdp: data.matriculaAdp,
                    nome: data.nome,
                    email: data.email,
                    isSelecionado: false,
                })
            );

            setTotalRecords(response.data?.meta?.totalRecords || 0);
            setProfessores(newProfs);
        }
    };

    useEffect(() => {
        setCurrentPage(0);
        getCR();
        if (props.crEdit) {
            setCrSelect(props.crEdit.cr);
            setProfessores(props.crEdit.professores);
            setTotalRecords(props.crEdit.professores.length);
            !props.crEdit.isAll && setStep(1);
        }
    }, [props.open]);

    const onSelect = (value: any[]) => {
        setCrSelect(value);
        value.length > 0 && getProfessores(value[0].value);
    };

    const handleCheck = (docenteId: string) => {
        const newProfessores: IProfessores[] = professores.map((prof) => {
            if (prof.docenteId === docenteId) {
                // eslint-disable-next-line no-param-reassign
                prof.isSelecionado = !prof.isSelecionado;
            }
            return prof;
        });

        setProfessores([...newProfessores]);
        return 0;
    };

    function handleNextPaginate(_page: string) {
        if ((currentPage + 1) * itensPerPage > totalRecords) {
            return;
        }
        setCurrentPage(currentPage + 1);
    }

    function handleCurrentPaginate(_page: string) {
        if ((currentPage - 1) * itensPerPage > totalRecords) {
            return;
        }
        setCurrentPage(currentPage - 1);
    }

    const selectCampus = () => {
        return (
            <>
                <StyledModalTitle style={{ marginBottom: "25px" }}>
                    Selecione o CR para incluir os professores
                </StyledModalTitle>
                <div />
                <Row>
                    <Col>
                        <AutocompleteCombo
                            label="Selecione a CR Escola"
                            options={crs}
                            selected={crSelect}
                            onChange={(value: any) => onSelect(value)}
                            placeholder="Selecione a CR Escola"
                            extraOptions
                        />
                    </Col>
                </Row>
                {crSelect.length > 0 ? (
                    <div>
                        {props.crEdit ? (
                            <StyledContainerButton>
                                <BtnPrimary disabled style={{ width: "100%" }}>
                                    Todos os professores selecionados
                                </BtnPrimary>
                            </StyledContainerButton>
                        ) : (
                            <div>
                                <StyledContainerButton>
                                    <BtnPrimary
                                        disabled={props.crSelect.find((item) =>
                                            item.cr.find(
                                                (cr) =>
                                                    cr.value ===
                                                    crSelect[0].value
                                            )
                                        )}
                                        onClick={() => {
                                            setCrSelect([]);
                                            const newCrs: ICrs[] =
                                                props.crSelect;
                                            newCrs.push({
                                                cr: crSelect,
                                                professores: [],
                                                isAll: true,
                                            });
                                            props.setCrSelect(newCrs);
                                            props.onClose();
                                        }}
                                        style={{ width: "100%" }}
                                    >
                                        Selecionar todos os professores
                                    </BtnPrimary>
                                </StyledContainerButton>
                                <StyledContainerButton>
                                    <BtnOutlinePrimary
                                        disabled={props.crSelect.find((item) =>
                                            item.cr.find(
                                                (cr) =>
                                                    cr.value ===
                                                    crSelect[0].value
                                            )
                                        )}
                                        onClick={() => {
                                            setStep(1);
                                        }}
                                        style={{ width: "100%" }}
                                    >
                                        Selecionar professores específicos
                                    </BtnOutlinePrimary>
                                </StyledContainerButton>
                            </div>
                        )}
                    </div>
                ) : (
                    <StyledContainerButton>
                        <BtnPrimary disabled style={{ width: "100%" }}>
                            Selecionar
                        </BtnPrimary>
                    </StyledContainerButton>
                )}
                <StyledContainerButton>
                    <DefaultButtonLink
                        onClick={() => {
                            setCrSelect([]);
                            props.onClose();
                        }}
                    >
                        Cancelar
                    </DefaultButtonLink>
                </StyledContainerButton>
            </>
        );
    };

    const pagination = totalRecords > itensPerPage && (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "74px",
                borderWidth: "0 1px 1px 1px",
                borderColor: "#E4E4E4",
                borderStyle: "solid",
                marginLeft: 10,
            }}
        >
            <div style={{ marginTop: 5 }}>
                <StyledLabel>Itens por página: {itensPerPage}</StyledLabel>
            </div>
            <div style={{ marginTop: 5 }}>
                <StyledLabel>{currentPage * itensPerPage + 1}-</StyledLabel>
                <StyledLabel>
                    {(currentPage + 1) * itensPerPage} de {totalRecords}
                </StyledLabel>
            </div>
            <LeftArrow
                style={{
                    cursor: currentPage === 0 ? "default" : "pointer",
                    fill: currentPage === 0 ? "#C4A0FF" : "#9654FF",
                    marginRight: "12px",
                }}
                onClick={() =>
                    currentPage === 0
                        ? null
                        : handleCurrentPaginate(String(currentPage))
                }
            />
            <RightArrow
                style={{
                    cursor:
                        (currentPage + 1) * itensPerPage > totalRecords
                            ? "default"
                            : "pointer",
                    fill:
                        (currentPage + 1) * itensPerPage > totalRecords
                            ? "#C4A0FF"
                            : "#9654FF",
                    marginLeft: "12px",
                    marginRight: "16px",
                }}
                onClick={() =>
                    (currentPage + 1) * itensPerPage > totalRecords
                        ? null
                        : handleNextPaginate(String(currentPage))
                }
            />
        </div>
    );

    const selectProfessores = () => {
        return (
            <>
                <StyledModalTitle style={{ marginBottom: "25px" }}>
                    Selecione o CR para incluir os professores
                </StyledModalTitle>
                <div />
                <Row>
                    <Col>
                        <AutocompleteFloatLabel
                            label="Selecione a CR Escola"
                            options={crs}
                            selected={crSelect}
                            onChange={(value: any) => onSelect(value)}
                            disabled
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TableStyles.TablePrimary
                            bordered
                            striped
                            responsive
                            style={{ marginBottom: 0 }}
                        >
                            <thead>
                                <tr>
                                    <th>Nome do Professor</th>
                                    <th>Matrícula</th>
                                    <th>Adicionar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {professores?.length === 0 ? (
                                    <tr key={uuid()} className="table-empty">
                                        <td colSpan={7}>Sem informações</td>
                                    </tr>
                                ) : (
                                    professores
                                        .slice(
                                            currentPage * itensPerPage,
                                            currentPage * itensPerPage +
                                                itensPerPage
                                        )
                                        .map((item) => (
                                            <tr key={uuid()}>
                                                <td>{item.nome}</td>
                                                <td>{item.matriculaAdp}</td>
                                                <td>
                                                    <StyledFormCheck
                                                        type="checkbox"
                                                        id={item.docenteId}
                                                        checked={
                                                            item.isSelecionado
                                                        }
                                                        onChange={() => {
                                                            handleCheck(
                                                                item.docenteId
                                                            );
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                )}
                            </tbody>
                        </TableStyles.TablePrimary>
                    </Col>
                    {pagination}
                </Row>
                <div>
                    <StyledContainerButton>
                        <BtnPrimary
                            onClick={() => {
                                setCrSelect([]);
                                const newCrs: ICrs[] = props.crSelect;
                                if (props.crEdit) {
                                    newCrs[props.indexCrEdit].professores =
                                        professores;
                                    props.setCrSelect(newCrs);
                                } else {
                                    newCrs.push({
                                        cr: crSelect,
                                        professores,
                                        isAll: false,
                                    });
                                    props.setCrSelect(newCrs);
                                }
                                props.onClose();
                            }}
                            style={{ width: "100%" }}
                        >
                            Adicionar professores
                        </BtnPrimary>
                    </StyledContainerButton>
                </div>
                <StyledContainerButton>
                    <DefaultButtonLink
                        onClick={() => {
                            setCrSelect([]);
                            props.onClose();
                        }}
                    >
                        Cancelar
                    </DefaultButtonLink>
                </StyledContainerButton>
            </>
        );
    };

    return (
        <Dialog
            openModal={props.open}
            onHide={() => {
                setCrSelect([]);
                props.onClose();
            }}
            size="width-800"
        >
            {step === 0 && selectCampus()}
            {step === 1 && selectProfessores()}
        </Dialog>
    );
}

export default ModalProfessores;
